import { render, staticRenderFns } from "./ScrollList.vue?vue&type=template&id=21bf2d90"
import script from "./ScrollList.vue?vue&type=script&lang=js"
export * from "./ScrollList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports